module.exports = __webpack_public_path__ + "img/gsb20.2f107716.png";